<template>
  <div class="">
    <div class="row">
      <div class="col-12">
        <app-note
          class="mb-primary"
          :title="$t('Recordatorio del código de confidencialidad')"
          :notes="[
            'Se recuerda a usted, la obligación y responsabilidad sobre el cumplimiento del código de ética y confidencialidad de la información F MGA1 01 que mantiene suscrito con el Servicio de Acreditación Ecuatoriano SAE, por lo cual la información a la que accede o genere en este proceso es estrictamente confidencial, de no darse cumplimiento el SAE iniciará las acciones legales pertinentes.',
          ]"
        />
      </div>
      <div class="col-12" v-if="test_combo">
        <legend>
          <p class="text-primary">Seguimiento de testificaciones</p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>CÓDIGO</th>
              <th>PLANIFICADO DESDE</th>
              <th>PLANIFICADO HASTA</th>
              <th>ESTADO</th>
              <th>DOCUMENTACIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, i) in test_combo" :key="i">
              <td class="align-middle">
                {{ value.code }}
              </td>
              <td class="align-middle">
                {{ value.date_start }} | {{ value.time_start }}
              </td>
              <td class="align-middle">
                {{ value.date_end }} | {{ value.time_end }}
              </td>
              <td class="align-middle">
                <div v-for="(val, j) in value.historical_evaluation" :key="j">
                  <span
                    v-if="val.status.code == '508' && val.task_finished == 1"
                    class="badge badge-sm badge-pill badge-success"
                  >
                    Ejecutado
                  </span>
                  <span
                    v-if="val.status.code == '508' && val.task_finished == 0"
                    class="badge badge-sm badge-pill badge-warning"
                  >
                    Sin ejecutar
                  </span>
                </div>
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openModal(value.id)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12">
        <legend>
          <p class="text-primary">Documentos</p>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th>FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="accApp && accApp.request_signed">
              <td class="align-middle">Solicitud de Acreditación</td>
              <td class="align-middle">
                {{ accApp.request_signed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(accApp, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="accApp && accApp.receipt_return_report">
              <td class="align-middle">Registro de Ingreso de solicitud de acreditación y acuse recibo</td>
              <td class="align-middle">
                {{ accApp.receipt_return_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(accApp, 'receipt_return_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <!-- <tr v-if="accApp && evalTest.showDocuments">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle">
                {{ accApp.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${accApp.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr> -->
            <tr v-if="evalTest && evalTest.file_evaluation">
              <td class="align-middle">Propuesta del Equipo Evaluador</td>
              <td class="align-middle">
                {{ evalTest.file_evaluation_date | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'file_evaluation')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.sampling_plan_file">
              <td class="align-middle">Plan de muestreo</td>
              <td class="align-middle">
                {{ evalTest.sampling_plan_file.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'sampling_plan_file')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.risk_matrix">
              <td class="align-middle">Matriz de riesgos</td>
              <td class="align-middle">
                {{ evalTest.risk_matrix.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'risk_matrix')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest && evalTest.risk_matrix505">
              <td class="align-middle">
                Matriz Análisis de riesgos y programa
              </td>
              <td class="align-middle">
                {{ evalTest.risk_matrix505.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'risk_matrix505')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest && evalTest.proforma">
              <td class="align-middle">
                Proforma
              </td>
              <td class="align-middle">
                {{ evalTest.proforma.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'proforma')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr 
                v-for="(item, key) in evalTest.evaluation_team" :key="key"
            >
              <td class="align-middle">Designación {{item.evaluator.first_name}} {{item.evaluator.last_name}}</td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                    class="btn btn-success"
                    :href="item.evaluation_team_designation.path"
                    target="_blank"
                ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>

            <tr v-if="evalTest && evalTest.report_documentary_evaluation">
              <td class="align-middle">Informe de Evaluación Documental</td>
              <td class="align-middle">
                {{
                  evalTest.report_documentary_evaluation.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'report_documentary_evaluation')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.first_instance_finding403">
              <td class="align-middle">
                (Evaluación Documental) Primera entrega - Informe para el cierre
                de hallazgos y decisión
              </td>
              <td class="align-middle">
                {{ evalTest.first_instance_finding403.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'first_instance_finding403')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.request_additional_evidence">
              <td class="align-middle">
                (Evaluación Documental) Solicitud de Evidencias Adicionales
              </td>
              <td class="align-middle">
                {{
                  evalTest.request_additional_evidence.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'request_additional_evidence')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.second_instance_finding403">
              <td class="align-middle">
                (Evaluación Documental) Segunda entrega - Informe para el cierre
                de hallazgos y decisión
              </td>
              <td class="align-middle">
                {{
                  evalTest.second_instance_finding403.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'second_instance_finding403')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.evaluation_plan_report">
              <td class="align-middle">Plan de Evaluación</td>
              <td class="align-middle">
                {{ evalTest.evaluation_plan_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'evaluation_plan_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <!-- <tr v-if="evalTest && evalTest.accepted_evaluation_plan">
              <td class="align-middle">
                Plan de Evaluación (Aprobado por el OEC)
              </td>
              <td class="align-middle">
                {{ evalTest.accepted_evaluation_plan.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'accepted_evaluation_plan')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
            <tr v-if="evalTest && evalTest.remote_in_situ_assessment_report">
              <td class="align-middle">
                Informe de Evaluación InSitu / Remota
              </td>
              <td class="align-middle">
                {{
                  evalTest.remote_in_situ_assessment_report.created_at
                    | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'remote_in_situ_assessment_report')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest && evalTest.testification_report">
              <td class="align-middle">Informe de Testificación</td>
              <td class="align-middle">
                {{ evalTest.testification_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'testification_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.first_instance_finding601">
              <td class="align-middle">
                (No Conformidades) Primera entrega - Informe para el cierre de
                hallazgos y decisión
              </td>
              <td class="align-middle">
                {{ evalTest.first_instance_finding601.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'first_instance_finding601')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.second_instance_finding601">
              <td class="align-middle">
                (No Conformidades)Informe para el cierre de hallazgos y decisión
                primera evidencia adicional
              </td>
              <td class="align-middle">
                {{
                  evalTest.second_instance_finding601.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'second_instance_finding601')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.third_instance_finding601">
              <td class="align-middle">
                (No Conformidades) Informe para el cierre de hallazgos y
                decisión segunda evidencia adicional
              </td>
              <td class="align-middle">
                {{ evalTest.third_instance_finding601.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'third_instance_finding601')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest && evalTest.accreditation_applications && (evalTest.accreditation_applications.accreditation_type_id == 1 ||
            evalTest.accreditation_applications.accreditation_type_id == 2 ||
            evalTest.accreditation_applications.accreditation_type_id == 10 ||
            evalTest.accreditation_applications.accreditation_type_id == 11      
            )">
              <td class="align-middle">Anexos de solicitud</td>
              <td class="align-middle">
                {{
                  evalTest.accreditation_applications.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabDownload()"
                >
                  {{ $t("Descargar comprimido") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12" v-if="evalTest.evaluation_team && Array.isArray(evalTest.evaluation_team) && evalTest.evaluation_team.some(item => item.evaluation_team_external)">
        <legend>
          <p class="text-primary">
            Anexos de honorarios del personal externo
          </p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ext in evalTest.evaluation_team" :key="ext.id">
                <td class="align-middle" v-if="ext.evaluation_team_external">{{ ext.evaluation_team_external.file_name }}</td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  {{
                      ext.evaluator
                        ? `${ext.evaluator.first_name} ${ext.evaluator.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  {{ ext.evaluation_team_external.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  <button type="submit" class="btn btn-success" @click.prevent="openTab(ext,'evaluation_team_external')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
          </tbody>
        </table>
        <!-- <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col" class="align-middle">NOMBRE</th>
              <th scope="col" class="
                  align-middle
                  text-center
                " style="width: 25%">
                USUARIO
              </th>
              <th scope="col" class="align-middle text-center" style="width: 15%">
                FECHA
              </th>
              <th scope="col" class="align-middle text-center" style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.evalAnnexesFiles" :key="i">
              <td class="align-middle">{{ v.filename }}</td>
              <td class="align-middle text-center">
                {{
                    v.annexed.user
                      ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                      : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ v.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(v.annexed.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            
            <tr v-for="ext in evalTest.evaluationTeam" :key="ext.id">
              <td class="align-middle" v-if="ext.evaluation_team_external">{{ ext.evaluation_team_external.file_name }}</td>
              <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                {{
                    ext.evaluator
                      ? `${ext.evaluator.first_name} ${ext.evaluator.last_name}`
                      : ""
                }}
              </td>
              <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                {{ ext.evaluation_team_external.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                <button type="submit" class="btn btn-success" @click.prevent="openTabExt(ext,'evaluation_team_external')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>

      <div class="col-12" v-if="evalTest.type == 'E'">
        <legend>
          <p class="text-primary">
            Documentación del OEC previo a la
            <span class="title-legend" v-if="evalTest.type == 'E'"
              >evaluación</span
            >
            <span class="title-legend" v-if="evalTest.type == 'T'"
              >testificación</span
            >
          </p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.management_system_file" :key="i">
              <td class="align-middle">
                {{ v.filename }}
              </td>
              <td class="align-middle text-center">
                <span v-if="v.annexed">
                  {{ v.annexed.user.first_name }}
                  {{ v.annexed.user.last_name }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span>{{ v.created_at | dateFormat }}</span>
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(v, 'annexed')"
                  v-if="v.annexed"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12" v-if="evalTest.standard_evaluate">
        <legend class="text-primary">
          <p>Borrador del plan de evaluación</p>
        </legend>
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="align-middle">
                <small class="text-primary">{{
                  evalTest.standard_evaluate.path.split("/")[
                    evalTest.standard_evaluate.path.split("/").length - 1
                  ]
                }}</small>
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.standard_evaluate.user
                    ? `${evalTest.standard_evaluate.user.first_name} ${evalTest.standard_evaluate.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.standard_evaluate.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTabAditional(evalTest.standard_evaluate)
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-sm-12"
        v-if="
          evalTest.testification_certification_aditional &&
          evalTest.testification_certification_aditional.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            Documentación del OEC previo a la testificación
          </p>
        </legend>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="width: 20%">
                NOMBRE DEL ARCHIVO
              </th>
              <th scope="col">CARGADO POR</th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(v, i) in evalTest.testification_certification_aditional"
              :key="'e' + i"
            >
              <td class="text-center">
                {{ v.filename }}
              </td>
              <td>{{ v.annexed.user.full_name }}</td>
              <td class="text-center">
                {{ v.created_at | dateFormat }}
              </td>
              <td class="text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabAditional(v.annexed)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>



      <div
        class="col-sm-12"
        v-if="
          evalTest.last_evaluation_document &&
          evalTest.last_evaluation_document.length > 0
        "
      >
      <legend class="text-primary">
            <p>
              Documentación previo a la 
              {{ evalTest.type == 'E' ? 'evaluación':  'testificación' }}
               - (Gestor Técnico)
            </p>
          </legend>
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="width: 20%">
                NOMBRE DEL ARCHIVO
              </th>
              <th scope="col">CARGADO POR</th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(v, i) in evalTest.last_evaluation_document"
              :key="'e' + i"
            >
              <td class="text-center">
                {{ v.filename }}
              </td>
              <td>{{ v.annexed.user.full_name }}</td>
              <td class="text-center">
                {{ v.created_at | dateFormat }}
              </td>
              <td class="text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabAditional(v.annexed)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="col-12" v-if="evalTest.action_plan">
          <legend class="text-primary">
            <p>Plan de acción - (OEC)</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="evalTest.action_plan">
                <td class="align-middle">
                  Plan de acción
                </td>
                <td class="align-middle text-center">
                  {{
                      evalTest.action_plan.user
                        ? `${evalTest.action_plan.user.first_name} ${evalTest.action_plan.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ evalTest.action_plan.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest,'action_plan')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      <div class="col-12" v-if="
          evalTest.historical512 && evalTest.historical512.length > 0
        ">
          <legend class="text-primary">
            <p>Historico de plan de acción</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(historical, i) in evalTest.historical512" :key="i">
                <td class="align-middle">
                  Plan de acción - {{ i + 1 }}
                </td>
                <td class="align-middle text-center">
                  {{
                      historical.user
                        ? `${historical.user.first_name} ${historical.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ historical.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest.historical512,i)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          evalTest.observation_plan_action
        ">
          <legend class="text-primary">
            <p>Correciones del plan de acción - (Evaluador Líder)</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  Correciones
                </td>
                <td class="align-middle text-center">
                  {{
                      evalTest.observation_plan_action.user
                        ? `${evalTest.observation_plan_action.user.first_name} ${evalTest.observation_plan_action.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ evalTest.observation_plan_action.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest,'observation_plan_action')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          evalTest.historical513 && evalTest.historical513.length > 0
        ">
          <legend class="text-primary">
            <p>Historico de correciones del plan de acción</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(historical, i) in evalTest.historical513" :key="i">
                <td class="align-middle">
                  Corrección del plan de acción - {{ i + 1 }}
                </td>
                <td class="align-middle text-center">
                  {{
                      historical.user
                        ? `${historical.user.first_name} ${historical.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ historical.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest.historical513,i)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="evalTest.report_plan_action">
          <legend class="text-primary">
            <p>Informe para el cierre de No Conformidades del plan de acción</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="evalTest.report_plan_action">
                <td class="align-middle">
                  Informe para el cierre de No Conformidades de OEC y para la Decisión
                </td>
                <td class="align-middle text-center">
                  {{
                      evalTest.report_plan_action.user
                        ? `${evalTest.report_plan_action.user.first_name} ${evalTest.report_plan_action.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ evalTest.report_plan_action.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest,'report_plan_action')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      <div
        class="col-12"
        v-if="
          evalTest.attendance_record && evalTest.attendance_record.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Registro de asistencia participación
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in evalTest.attendance_record"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest.attendance_record, key)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.preparation_meeting &&
          evalTest.preparation_meeting.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Reunión de preparación de evaluación
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in evalTest.preparation_meeting"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest.preparation_meeting, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.evaluation_questionnaire &&
          evalTest.evaluation_questionnaire.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Cuestionario de Evaluación Técnicos
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in evalTest.evaluation_questionnaire"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest.evaluation_questionnaire, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.expert_participation_record &&
          evalTest.expert_participation_record.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Informe Participación Expertos Técnicos
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in evalTest.expert_participation_record"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest.expert_participation_record, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="evalTest.other_file_505 && evalTest.other_file_505.length > 0"
      >
        <legend>
          <p class="text-primary">
            (Evaluación InSitu / Remota) Otros archivos cargados
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in evalTest.other_file_505" :key="key">
                  <td class="align-middle">
                    {{ value.filename }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.annexed.user
                        ? `${value.annexed.user.first_name} ${value.annexed.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTabList(value.annexed, key)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        class="col-12"
        v-if="
          evalTest.attendance_record_testification &&
          evalTest.attendance_record_testification.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Testificación) Registro de asistencia participación
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    value, key
                  ) in evalTest.attendance_record_testification"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest.attendance_record_testification, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.testification_evaluation_questionnaire &&
          evalTest.testification_evaluation_questionnaire.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Testificación) Cuestionario de Testificación Técnicos
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    value, key
                  ) in evalTest.testification_evaluation_questionnaire"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(
                          evalTest.testification_evaluation_questionnaire,
                          key
                        )
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.expert_participation_record_testification &&
          evalTest.expert_participation_record_testification.length > 0
        "
      >
        <legend>
          <p class="text-primary">
            (Testificación) Informe Participación Expertos Técnicos
          </p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    value, key
                  ) in evalTest.expert_participation_record_testification"
                  :key="key"
                >
                  <td class="align-middle">
                    {{ value.file_name }} {{ key + 1 }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      value.user
                        ? `${value.user.first_name} ${value.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ value.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(
                          evalTest.expert_participation_record_testification,
                          key
                        )
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        v-if="
          evalTest.testification_509_1 &&
          evalTest.testification_509_1.length > 0
        "
      >
        <legend class="col-12 col-form-label text-primary pt-0 my-3">
          <h5>Entrega de Informes y documentación de la testificación</h5>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col" class="align-middle">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 15%"
              >
                FECHA
              </th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 10%"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.testification_509_1" :key="i">
              <td class="align-middle">{{ v.filename }}</td>
              <td class="align-middle text-center">
                {{
                  v.annexed.user
                    ? `${v.annexed.user.first_name} ${v.annexed.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ v.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTabList(v.annexed)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="col-12 mt-4"
        v-if="
          evalTest.support_management_non_conformities_601_1 &&
          evalTest.support_management_non_conformities_601_1.length > 0
        "
      >
        <legend class="text-primary">
          Respaldo informe para el cierre de hallazgos y decisión primera
          entrega
        </legend>
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(
                value, key
              ) in evalTest.support_management_non_conformities_601_1"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        evalTest.support_management_non_conformities_601_1,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12 mt-4"
        v-if="
          evalTest.support_management_non_conformities_601_2 &&
          evalTest.support_management_non_conformities_601_2.length > 0
        "
      >
        <legend class="text-primary">
          Respaldo informe para el cierre de hallazgos y decisión primera
          evidencia adicional
        </legend>
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(
                value, key
              ) in evalTest.support_management_non_conformities_601_2"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        evalTest.support_management_non_conformities_601_2,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12 mt-4"
        v-if="
          evalTest.support_management_non_conformities_601_3 &&
          evalTest.support_management_non_conformities_601_3.length > 0
        "
      >
        <legend class="text-primary">
          Respaldo informe para el cierre de hallazgos y decisión segunda
          evidencia adicional
        </legend>
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(
                value, key
              ) in evalTest.support_management_non_conformities_601_3"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        evalTest.support_management_non_conformities_601_3,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <audit-eval-test-modal
      v-if="isModalActive"
      :eval-test-id="evalTestIdd"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  data() {
    return {
      test_combo: {},
      acc_app_id: "",
      isModalActive: false,
      evalTestIdd: null,
      evalTestId: null,
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },
    directory() {
      return this.evalTest.id
        ? this.evalTest.type == "E"
          ? "Evaluación In Situ/Remota"
          : "Testificación"
        : "";
    },
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.evalTestId = this.$store.state.evaluatorReview.evalTestId;
    this.showAccApp();
    this.showTest();
  },
  methods: {
    openTab(obj, fileName) {
      var info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.evalTest.id;
      info['path'] = String(obj[fileName].path);
      this.$store.dispatch("registerFileLog", info);
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    openTabAditional(doc) {
      var info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.evalTest.id;
      info['path'] = String(doc.path);
      const w = window.open(doc.path, "_blank");
      w.focus();
    },

    openTabList(obj) {
      var info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.evalTest.id;
      info['path'] = String(obj.path);
      this.$store.dispatch("registerFileLog", info);
      const w = window.open(obj.path, "_blank");
      w.focus();
    },

    showAccApp() {
      let urla = `/evaluator/documentaryEvaluation/show/${this.evalTestId}`;
      axiosGet(urla).then((response) => {
        this.acc_app_id = response.data.accreditation_applications.id;
      });
    },

    openTabDownload() {
      let w;
      w = window.open(
        `/annexes/download?accAppId=${this.acc_app_id}`,
        "_blank"
      );
      w.focus();
    },

    showTest() {
      let url = `/evaluator/documentaryEvaluation/showComboTest/${this.evalTestId}`;
      axiosGet(url).then((response) => {
        this.test_combo = response.data;
      });
    },

    openModal(evalTestId) {
      this.evalTestIdd = evalTestId;
      this.isModalActive = true;
    },

    closeModal() {
      this.isModalActive = false;
    },
  },
};
</script>
<style>
.title-legend {
  font-size: 1em;
}
</style>
